// extracted by mini-css-extract-plugin
export default {"cls1":"qkwLezuQqPtI_61IKhD1","cls2":"Ab9rTbwWDrAy4QKdlOrm qkwLezuQqPtI_61IKhD1"};